import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';

Vue.config.productionTip = false

// Verify authentication on app load
store.dispatch('auth/verify').then(() => {
  new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
  }).$mount('#app');
});
